import type { HttpClient } from '~/shared/api'
import type { LoggerFactory } from '~/shared/interfaces'
import type { RequestRestService } from '../RequestRestService'
import { ArticleDetailService } from './ArticleDetailService'
import { ArticleMainService } from './ArticleMainService'
import { ArticleCommentsService } from './ArticleCommentsService'

export class ArticleService {
  readonly main: ArticleMainService
  readonly detail: ArticleDetailService
  readonly comments: ArticleCommentsService

  constructor(requestRest: RequestRestService, http: HttpClient, createLogger: LoggerFactory) {
    this.main = new ArticleMainService(http)
    this.detail = new ArticleDetailService(requestRest, http, createLogger('ArticleDetailService'))
    this.comments = new ArticleCommentsService(http)
  }
}
